module ContentEditableDiv {
  export function construct() {
    $("form").submit(onFormSubmit);
    $("div[contenteditable]").keypress(onKeypress);
    //Populate backing inputs with current div value
    $("div[contenteditable][data-backingfield]").each(function (index: number) {
      const div = $(this);
      const backingInput = getBackingInput(div);
      backingInput.val(div.html());
    });
  }

  export function getIfDivChanged(div: JQuery<HTMLElement>) {
    const currentValue = div.html();
    const backingInput = getBackingInput(div);
    const previousValue = backingInput.val();
    return currentValue != previousValue;
  }

  function onFormSubmit(event: JQuery.Event<HTMLElement, null>) {
    var form = $(event.target);
    var contentEditableDivs = form.find("div[contenteditable][data-backingfield]");
    contentEditableDivs.each((index, element) => {
      var div = $(element);
      updateBackingField(div);
    });
  }

  function updateBackingField(div: JQuery<HTMLElement>) {
    var backingInput = getBackingInput(div);
    backingInput.val(div.html());
  }

  function onKeypress(event: JQuery.Event<HTMLElement, null>) {
    var div = $(event.target);
    updateBackingField(div);

    if (div.data("submit") === "enter") {
      if (event.which === 13) {
        var form = div.parents("form");
        form.submit();
        event.preventDefault();
      }
    }
  }

  export function getBackingInput(div: JQuery<HTMLElement>): JQuery<HTMLElement> {
    return $("#" + div.data("backingfield"));
  }
}